<div class="expansion-panel" [class.expanded]="expanded" [class.disabled]="disabled">
  <div [class]="compact?'expansion-panel-header-compact':'expansion-panel-header'" (click)="toggle()">
    <span class="caret" [class.rotated]="expanded"></span>
    <div class="header-content">
      <ng-content select="[header]"></ng-content>
    </div>
  </div>
  
  <div [class]="compact?'expansion-panel-content-compact':'expansion-panel-content'" [class.expanded]="expanded">
    <div [class]="compact?'content-wrapper-compact':'content-wrapper'">
      <ng-content></ng-content>
    </div>
  </div>
</div>